<template>
    <div name="duplicate-modal" class="wrapper">
        <div class="modal">
            <div class="touch" @click="onClose()">

            </div>
            <div class="contents">
                <span class="title">등록된 환자 정보가 있네요!</span>
                <span style="margin-top: 35px;;" class="text1">환자 정보: <span class="text2">{{ name }}</span></span>
                <span class="description">이미 환자 정보가 등록되어 있어요.<br>
                    환자정보 관리에서 등록된 정보를 확인해주세요.</span>
                <div class="button" @click="onClose">확인</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'duplicateModal',
    props: ['name'],
    methods: {
        onClose: function()
        {
            this.$emit('onClose')
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

    }
    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px; /* 116.667% */
    }
    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.7);
        max-width: 600px;
        width: 100%;
        height: 100vh;
        z-index: 10;
        bottom: 0;
        box-sizing: border-box;
    }

    @media (min-width: 600px) {
        .modal {
            width: 600px;
        }
    }

    .touch {
        height: calc(100vh - 314px);
        width: 100vw;
    }
    .contents {
        background: #FFFFFF;
        height: 314px;
        width: 100%;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding-top: 34px;
        padding-left: 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
    }

    .text1 {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 120% */

    }
    .text2 {
        color: #184FA1;
        text-align: right;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 8px;
    }
    .description {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 120% */
        margin-top: 25px;
    }

    .button {
        display: flex;
        width: calc(100% - 32px);
        height: 56px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        position: absolute;
        bottom: 30px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/DuplicateModal.vue